

$('.txt-slider').owlCarousel({
    center: true,
    loop:true,
    //center: true,
    margin:0,
    nav:false,
    dots:false,
    autoplay: true,
    slideTransition: 'linear',
    autoplayTimeout: 8000,
    autoplaySpeed: 25000,
    autoplayHoverPause: true,
    responsive:{
        0:{
            items: 1
        },
        610:{
            items:2
        },
        768:{
            items:2.5
        },
        991:{
            items: 3
        },
        1200:{
            items:3.2
        },
        1500:{
            items: 4.5        
        },
        1600:{
            items:4.5
        },
        1750:{
            items:5.5
        }
    }
});

$('.txt-slider2').owlCarousel({
    center: true,
    loop:true,
    //center: true,
    margin:0,
    nav:false,
    dots:false,
    autoplay: true,
    slideTransition: 'linear',
    autoplayTimeout: 8000,
    autoplaySpeed: 25000,
    autoplayHoverPause: true,
    responsive:{
        0:{
            items: 1
        },
        610:{
            items:2
        },
        768:{
            items:2.5
        },
        991:{
            items: 3
        },
        1200:{
            items:2.8
        },
        1500:{
            items: 3.2        
        },
        1600:{
            items:3.6
        },
        1750:{
            items:4
        }
    }
});

$('.seller-carousel').owlCarousel({
    loop: true,
    //center: true,
    margin: 15,
    nav: true,
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
    dots: false,
    autoplay: false,
    smartSpeed: 3000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        767: {
            items: 1.7,
        },
        992: {
            items: 2,
        },
        1200: {
            items:2.5,
        }
    }
});

$('.v-slider1').slick({
  dots: false,
  arrows: false,
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0, // Set to 0 for continuous movement
  infinite: true,
  speed: 6000, // This controls the actual animation speed
  pauseOnHover: false,
  cssEase: 'linear',
  useCSS: true, // Enable CSS transitions
  useTransform: true
});

$('.v-slider2').slick({
  dots: false,
  arrows: false,
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0, // Set to 0 for continuous movement
  infinite: true,
  speed: 6000, // Match the speed for consistency
  pauseOnHover: false,
  cssEase: 'linear',
  useCSS: true, // Enable CSS transitions
  useTransform: true
});


/*####### Shop page js*/ 

$(document).ready(function () {
    $(".category_head .plusminus").click(function () {
        let head = $(this).parent(); // go up to .accordion_head
        let body = head.next(".category_nav_wrap"); // get its sibling body

        if (body.is(':visible')) {
            body.slideUp(300);
            $(this).text('+');
        } else {
            $(".category_nav_wrap").slideUp(300); // close all
            $(".plusminus").text('+');         // reset all plus
            body.slideDown(300);               // open this one
            $(this).text('-');                 // set minus
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-add-to-cart-form").forEach(function(form) {
    form.addEventListener("submit", function(e) {
      e.preventDefault();

      let cartDrawer = document.querySelector("cart-drawer");
      const formData = new FormData(form);

      const body = {
        items: [{ id: formData.get("id"), quantity: 1 }],
        sections: cartDrawer.getSectionsToRender().map(section => section.id),
        sections_url: window.location.pathname
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
      .then(res => res.json())
      .then(data => {
        cartDrawer.renderContents(data);
        cartDrawer.classList.remove("is-empty");
        cartDrawer.open();
      })
      .catch(err => console.error("Add to cart error:", err));
    });
  });

//   banner video js

//     const video = document.getElementById("mainVideo");
//   const btn = document.getElementById("soundToggleBtn");

//   btn.addEventListener("click", function () {
//     if (video.muted) {
//       video.muted = false;
//       btn.textContent = "🔇";
//     } else {
//       video.muted = true;
//       btn.textContent = "🔊";
//     }
//     video.play();
//   });


});


